<template>
    <div>
        <v-pagination
                v-model="currentPage"
                :length="totalPage"
                total-visible="8"
                circle
        ></v-pagination>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        props: ['page', 'totalPage'],
        computed:{
            currentPage: {
                get(){
                    return this.page;
                },
                set(value){
                    this.$emit('paginate', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>